export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            投稿、合作或反馈建议，我们期待你的声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-50 flex items-center justify-center">
              <i className="ri-mail-line text-primary-500 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">商务合作</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
              广告投放、IP 合作、品牌联名
            </p>
            <p className="text-xs text-primary-600 font-medium whitespace-nowrap">
              biz@planetcomic.cn
            </p>
          </div>

          <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-50 flex items-center justify-center">
              <i className="ri-pencil-line text-accent-500 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">作者投稿</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
              漫画创作者入驻与作品投稿
            </p>
            <p className="text-xs text-accent-600 font-medium whitespace-nowrap">
              submit@planetcomic.cn
            </p>
          </div>

          <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-secondary-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">用户反馈</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
              意见反馈、问题报告、功能建议
            </p>
            <p className="text-xs text-secondary-600 font-medium whitespace-nowrap">
              feedback@planetcomic.cn
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}